import axios from 'axios';
import { Repository, RepositoryRequest } from './models/Repository';

export const getRepositories = async (
  projectId: string,
): Promise<Repository[]> => {
  const { data } = await axios.get<Repository[]>(
    `${window.configuration.apiUrl}api/GithubRepositories/${projectId}`,
  );
  return data;
};

export const createRepository = async (request: RepositoryRequest): Promise<void> => {
  await axios.post(
    `${window.configuration.apiUrl}api/GithubRepositories`,
    request,
    { headers: { 'Content-Type': 'application/json' } },
  );
};

export const deleteRepository = async (request: RepositoryRequest): Promise<void> => {
  await axios.delete(
    `${window.configuration.apiUrl}api/GithubRepositories`,
    {
      data: request,
      headers: { 'Content-Type': 'application/json' },
    },
  );
};

export const validateRepositoryExists = async (
  toolId: string,
  repositoryName: string,
): Promise<boolean> => {
  const { data } = await axios.get<boolean>(
    `${window.configuration.apiUrl}api/GithubRepositories/validateRepositoryExists`,
    {
      params: {
        ToolId: toolId,
        RepositoryName: repositoryName,
      },
    },
  );

  return data;
};
